


























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import XLSX from "@/lib/Common/excel";
import DetailModal from "./linelossdetail.vue";
import SearchTree from "@/lib/Common/searchtree";

class PageUserRequest extends PageRequest {
  areaId: number;
  startTime: string;
  endTime: string;
  meterId: string;
  operaType: number = 0;
  /**表计类型 */
  meterType: number = 0;
  keyword: string;
}

@Component({
  components: { DetailModal },
})
export default class LineLoss extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  itemId: string = "0";
  height: number = 300;
  loadsear: boolean = false;
  detailModalShow: boolean = false; //显示明细窗口
  choosemeters: Array<any> = []; //选择表计
  meterId: string = "";
  startTime = "";
  endTime = "";
  rowCount: number = 0;
  list: any[] = [];
  pageSize: number = 10;
  currentPagenum: number = 1;
  splitnum: number = 0.15;
  /**表计类型 */
  meterType: any[] = [];

  /**
   * 获取计表类型
   */
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));

    let metert = detaillist.filter((p) => {
      return p.itemId == 7;
    });
    metert.forEach((ele) => {
      this.meterType.push({
        label: ele.name,
        value: ele.id,
      });
    });
    console.log(this.meterType)
  }

  get loading() {
    return this.$store.state.readrecord.loading;
  }
  //时间改变
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = Moment(val[0], "YYYY-MM-DD HH:mm:ss")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.startTime = this.pagerequest.startTime;
      this.endTime = this.pagerequest.endTime;
    }
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("readrecord/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("readrecord/setCurrentPage", 1);
    this.getpage();
  }
  //明细
  async detailing() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("OnlyOne"),
      });
      return;
    }
    //this.pagerequest.meterId = this.choosemeters[0];
    this.detailModalShow = true;
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.currentPagenum = page;
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    (this.pageSize = pagesize), this.getpage();
  }
  getpage() {
    this.pagerequest.skipCount = (this.currentPagenum - 1) * this.pageSize;
    this.loadsear = true;
    this.$store
      .dispatch({
        type: "readrecord/getLineLoss",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        this.rowCount = val.rowCount;
        this.list = val.tableData;
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }

  //列名称
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      type: "selection",
      width: 60,
      fixed: "left",
      align: "center",
      sortId: 1,
    },
    {
      sortable: true,
      title: this.L("Meter"),
      key: "meterNo",
      resizable: true,
      width: 130,
      fixed: "left",
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("ChildrenNum"),
      key: "totalCount",
      sortable: true,
      width: 130,
    },

    {
      sortable: true,
      title: this.L("Location"),
      key: "location",
      resizable: true,
      width: 130,
      fixed: "left",
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("TotalUse"),
      key: "totalUse",
      width: 130,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.totalUse.toFixed(2),
            },
          },
          params.row.totalUse.toFixed(2)
        );
      },
    },
    {
      title: this.L("ChildTotalUse"),
      key: "childTotalUse",
      width: 130,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.childTotalUse.toFixed(2),
            },
          },
          params.row.childTotalUse.toFixed(2)
        );
      },
    },
    {
      title: this.L("DiffTotalUse"),
      key: "diffTotalUse",
      width: 130,
      sortId: 9,
      resizable: true,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.diffTotalUse.toFixed(2),
            },
          },
          params.row.diffTotalUse.toFixed(2)
        );
      },
    },
    {
      title: this.L("LineLossRate"),
      key: "lineLossRate",
      width: 130,
      sortId: 9,
      resizable: true,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: (params.row.lineLossRate * 100).toFixed(2) + "%",
            },
          },
          (params.row.lineLossRate * 100).toFixed(2) + "%"
        );
      },
    },
    {
      title: this.L("StartTime"),
      key: "startReadTime",
      width: 150,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.startReadTime == null
            ? ""
            : Moment(params.row.startReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("EndTime"),
      key: "lastReadTime",
      width: 150,
      sortId: 9,
      resizable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : Moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Organizations"),
      key: "organizationName",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.organizationName,
            },
          },
          params.row.organizationName
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      sortable: true,
      title: this.L("CollectorId"),
      key: "collectorNo",
      resizable: true,
      width: 130,
      sortId: 2,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.collectorNo,
            },
          },
          params.row.collectorNo
        );
      },
    },
  ];
  async created() {
    this.pagerequest.startTime = Moment()
      .add(-6, "days")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getAreaTree();
    this.startTime = this.pagerequest.startTime;
    this.endTime = this.pagerequest.endTime;
    this.getItemDetail();
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 280;
    } else {
      this.height = window.innerHeight - 140;
    }
  }
  //选择
  onrowselect(val, index) {
    this.choosemeters.push(index.meterId);
    this.meterId = index.meterId;
  }
  //取消选择
  onrowselected(val, index) {
    this.choosemeters = this.choosemeters.filter((ele) => ele != index.meterId);
    this.meterId = "";
  }
  //全选
  handall(selection) {
    if (selection.length > 0) {
      this.choosemeters = [];
      selection.forEach((ele) => {
        this.choosemeters.push(ele.meterId);
      });
      this.meterId = this.choosemeters[0];
    }
  }
  //取消全选
  handallcancel(selection) {
    this.choosemeters = [];
    this.meterId = "";
  }
  //导出数据
  async exportdata() {
    this.loadsear = true;
    this.pagerequest.operaType = 1;
    await this.$store
      .dispatch({
        type: "readrecord/getLineLoss",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        console.log(val);
        this.exportList(val.tableData);
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  //XLXS导出数据
  exportList(list) {
    let title = [
      "区域",
      "客户名称",
      "手机",
      "客户类型",
      "控制类型",
      "总用量",
      "时间",
    ];
    let keylist = [
      "areaName",
      "customerName",
      "mobile",
      "customerType",
      "controlId",
      "thisUse",
      "readTimeStr",
    ];
    let filename = Moment().format("YYYYMMDDHHmmss");
    const param = {
      title: title,
      key: keylist,
      data: list,
      autoWidth: true,
      filename: filename,
    };
    XLSX.export_array_to_excel(param);
  }
  data() {
    return {
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
    };
  }
}
